/* global messg */
import { put } from 'redux-saga/effects'
import NProgress from 'nprogress'
import Bugsnag from '~/scenes/bugsnag'
import PropTypes from 'prop-types'

import I18n from 'lib/i18n'
import createForm from 'lib/kea/create-form'
import headerProps from 'lib/selectors/header-props'
import { removeLanguageUrlFromPath } from 'lib/utils/links'

import menuLogic from '../logic'

import controller from '../../controller.rb'

const form = createForm({
  path: () => ['scenes', 'header', 'countriesForm'],

  connect: {
    props: [menuLogic, ['countryMenuOptions']],
    actions: [menuLogic, ['closeCountryModal']]
  },

  propTypes: {
    country: PropTypes.string,
    language: PropTypes.number,
    currency: PropTypes.string
  },

  defaults: () => state => headerProps(state).countryMenuInformation,

  submitWhenNothingChanged: true,

  submit: function * () {
    const { toggleRedirecting } = this.actions

    NProgress.start()
    yield put(toggleRedirecting(true))

    const { country, language, currency } = yield this.get('values')
    const { languages, mapping } = yield this.get('countryMenuOptions')

    const languageObject = languages.filter(l => l.value === language)[0]
    const selectedLanguage = languageObject ? languageObject.shortcode : ''

    const countryInMapping = mapping[country.toLowerCase()]
    const languageInMapping = countryInMapping && countryInMapping.includes(selectedLanguage)

    const languageUrl = languageInMapping ? `/${selectedLanguage}-${country.toLowerCase()}` : `/${selectedLanguage}`

    let path = removeLanguageUrlFromPath(window.location.pathname)

    // Translate the category in the url if it's a long search url and remove the city - it will be re-generated anyway
    if (path.indexOf('/s/') === 0 && path.split('/').length >= 5) {
      try {
        const urlParts = path.split('/')
        urlParts[2] = '-'
        if (urlParts[3] !== '-') {
          const category = decodeURIComponent(urlParts[3])
          const response = yield controller.translateCategory({
            category,
            from_locale: I18n.locale,
            to_locale: selectedLanguage
          })
          if (response.category) {
            urlParts[3] = response.category
          }
        }
        path = urlParts.join('/')
      } catch (e) {} // Ignore if can't translate
    }

    const searchInUrl = [
      window.location.search,
      window.location.search ? '&' : '?',
      `_set_currency=${currency}`,
      languageInMapping ? '' : `&_set_country=${country}`
    ].join('')

    return `${languageUrl}${path}${searchInUrl}`
  },

  success: function (redirectUrl) {
    window.setTimeout(() => {
      window.location.href = redirectUrl
    }, 100)
    window.setTimeout(() => {
      window.location.href = redirectUrl
    }, 15000)
  },

  failure: function * (error) {
    const { toggleRedirecting } = this.actions

    Bugsnag.notify(error)
    messg.error(I18n.t('modals.error_text'), 2500)

    NProgress.done()
    yield put(toggleRedirecting(false))
  }
})

export default form

export const Field = form.getField()
